<template>
  <div style="background-color:#fff;min-height:500px" class="cont_inner">
    <div style="border:1px solid #cdcdcd">
      <div style="height:160px;background-color:#f9f9f9;border-bottom: 1px solid #cdcdcd ; display:flex; justify-content:center;align-items:center;padding:10px">
        <div style="width:180px;text-align:center;color:#f90000">
          <i class="el-icon-time" style="font-size:36px;"></i>
          <div style="margin-top:10px">等待付款</div>
        </div>
        <div style="display:flex;color:gray;text-align:center;flex:1">
          <div style="margin-left:7px">
            <div style="margin-bottom:7px;font-size: 16px;color: #999999 ">订单编号</div>
            <div style="font-size: 14px;color: #666666;">
              {{ orders.orderNo }}
            </div>
          </div>
          <div style="margin-left:18px">
            <div style="margin-bottom:7px;font-size: 16px;color: #999999 ">下单时间</div>
            <div style="font-size: 14px;color: #666666;">
              {{ orders.createTime }}
            </div>
          </div>
          <div style="margin-left:18px;margin-top:20px" >
            <div style="margin-bottom:7px;font-size: 14px;color: #999999 ">{{ timeLeft }}</div>
            <!-- <div style="font-size: 14px;color: #666666;">

            </div> -->
          </div>
        </div>
        <div style="padding-right:30px" v-if=" timeLeft != '已过期'">
          <div
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            style="cursor : pointer"
            @click="payOrderClick"
            v-if=' (orders.orderType == 0 && orders.payStatus == 0 && orders.orderStatus>=0 )  ||  ( orders.orderType == 1 && orders.presaleStatus == 1  && orders.payStatus ==0  && orders.orderStatus>=0 )  '

          >
            立即付款
          </div>
          <!-- <el-button type="primary" plain>取消订单</el-button> -->
        </div>

      </div>
      <div style="padding:40px;color:gray">
        <div style="font-size: 16px;color: #999999 ; margin-bottom:14px">商品信息</div>
        <el-table
          ref="multipleTable"
          :data="orders.apiOrderGoods"
          tooltip-effect="dark"
          style="width: 100% ; margin-top:20px;border:1px solid #e4e4e4"
          :row-style="{height: '100px'}"
          :header-cell-style="{background:'#F9F9F9',color:'#999999'}"
          @row-click='gotoDetail'
        >
          <el-table-column label="商品信息"  >
            <template slot-scope="scope">
              <div style="display:flex;   	">
                <el-image style="width: 50px; height: 50px" :src="publicUrl  + scope.row.goodsPic" fit="contain"></el-image>
                <div
                  style="flex:1;margin-left:8px;display:flex;flex-direction:column;justify-content:center"
                >
                  <div style="font-size: 14px;color: #333333;">{{ scope.row.goodsName }}</div>
                  <div style="font-size: 14px;color: #333333;" v-if=' scope.row.searchValue '>{{ scope.row.searchValue }}</div>
                  <div style="font-size: 14px;color: #333333;" v-if=' scope.row.vin '>{{ scope.row.vin }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="price" label="单价" width="250" align="center">
            <template slot-scope="scope">
              <div style="display:flex;justify-content:center">
                <div style="color: #7F7F7F;margin-right:20px">
                  <div>零售价</div>
                  <div>{{ scope.row.goodsPrice  ? '¥' + scope.row.goodsPrice  : ''  }}</div>
                </div>

                <div style="color: #E60012;margin-right:20px">
                  <div>拿货价</div>
                  <div>{{ scope.row.goodsDiscountPrice  ? '¥' + scope.row.goodsDiscountPrice  : '已失效'  }}</div>
                </div>

                <div style="color: #E60012;"   >
                  <div>实付金额</div>
                  <div>{{ scope.row.realAmount  ? '¥' + scope.row.realAmount  : ''  }}</div>
                </div>

                <div>
                </div>
              </div>
            </template>

          </el-table-column>

          <el-table-column prop="num" label="数量"  width="80" align="center">
            <template slot-scope="scope">
              {{  scope.row.quantity  }}{{  scope.row.salesUnit  }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="小计" width="120" align="center">
            <template slot-scope="scope">
              <div style="color:red"> {{ '¥' + (scope.row.goodsDiscountPrice * scope.row.quantity).toFixed(2) }} </div>
            </template>
          </el-table-column>

        </el-table>

        <div style="margin:34px 0 14px;font-size: 16px;color: #999999">收货信息</div>
        <div style="border:1px solid #cdcdcd ;padding:20px;font-size:14px;margin-bottom:30px">
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999 ">收货人:</span>
            {{ orders.receiverName }}
          </div>
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999 ">联系方式 :</span>
            {{ orders.receiverPhone }}
          </div>
          <div style="font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">收货地址 :</span>
            {{ orders.receiverProvince + orders.receiverCity + orders.receiverRegion + orders.receiverDetailAddress }}
          </div>
        </div>

        <!-- <div style="margin:34px 0 14px;font-size: 16px;color: #999999">支付方式及物流方式</div>
        <div style="border:1px solid #cdcdcd ;padding:20px;font-size:14px;margin-bottom:30px">
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">支付方式：</span>
            {{ orders.payChannel == 4 ? '银行转账'  : ''}}
            {{ orders.payChannel == 1 ? '微信'  : ''}}
          </div>
          <div style=";font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">物流方式：</span>
            {{ orders.expressCompany }}
          </div>
        </div> -->

        <div style="margin:34px 0 14px;font-size: 16px;color: #999999" v-if="orders.invoiceCity">发票信息</div>
        <div style="border:1px solid #cdcdcd ;padding:20px;font-size:14px;margin-bottom:30px" v-if="orders.invoiceCity">
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">发票类型：</span>
            {{ orders.invoiceProperty == 0 ? '增值税普通发票' : '增值税专用发票' }}
          </div>
          <div style="font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">发票抬头：</span>
            {{companyName }}
          </div>
        </div>

        <div style="margin:34px 0 14px;font-size: 16px;color: #999999">订单信息</div>
        <div style="border:1px solid #cdcdcd ;padding:20px;font-size:14px;margin-bottom:30px">
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">订单编号：</span>
            {{ orders.orderNo }}
          </div>
          <div style="font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">下单时间：</span>
            {{ orders.createTime }}
          </div>
        </div>

        <div style="margin:34px 0 14px;font-size: 16px;color: #999999">订单备注</div>
        <div style="border:1px solid #cdcdcd ;padding:20px;font-size:14px;margin-bottom:30px">
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            {{ orders.remark }}
          </div>
        </div>

        <div style="display:flex;margin-bottom:10px">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            商品件数：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            {{ orders.totalNum }}&nbsp;件
          </div>
        </div>
        <div style="display:flex;margin-bottom:10px">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            商品总价：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            ¥{{ orders.goodsTotalPrice}}
          </div>
        </div>
        <!--<div style="display:flex;margin-bottom:10px">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            活动优惠：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            -¥0
          </div>
        </div>-->
        <div style="display:flex;margin-bottom:10px">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            优惠券抵扣：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            -¥{{ orders.couponTotalPrice }}
          </div>
        </div>
        <div style="display:flex;margin-bottom:10px"  v-if="orders.orderType==1">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            预定优惠：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            -¥{{ orders.resvPrice }}
          </div>
        </div>
        <div style="display:flex;margin-bottom:10px">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            运费：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            ¥{{ orders.postage }}
          </div>
        </div>
        <div style="display:flex;margin-bottom:10px;margin-top:25px;line-height:22px;">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            应付总额：
          </div>
          <div style="width:150px;font-size: 20px;font-weight: 700;color: #D10217;;text-align:right">
            ¥{{ orders.payPrice}}
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="支付" :visible.sync="payVisible" width="600px" center
      :show-close='false'
      :close-on-press-escape='false'
      :close-on-click-modal	='false'
    >
      <div style="margin-bottom:10px">
        商户名称 : {{ payObj.company}}
      </div>
      <div style="margin-bottom:10px">
        订单编号 : {{ payObj.orderNo}}
      </div>
      <div style="margin-bottom:10px">
        支付方式 : {{ payObj.payChannel == 1 ? '微信' : ''}}{{ payObj.payChannel == 2 ? '支付宝' : ''}}{{ payObj.payChannel == 4 ? '银行转账' : ''}}
      </div>
      <div style="margin-bottom:10px">
        支付价格 : ¥{{ payObj.price}}
      </div>
      <div style="margin-bottom:5px">
        {{ timeLeft }}
      </div>

      <div style="width:100%;;margin-bottom:10px;display:flex;">
        <el-image
          style="width: 300px; "
          :src=' "data:image/jpeg;base64," + payObj.code_image '
          fit="contain"
        ></el-image>
        <el-image
          style="width: 300px; margin-left:10px"
          :src=' weixinPhone '
          fit="contain"
          v-if="payObj.payChannel == 1"
        ></el-image>
        <el-image
          style="width: 300px; margin-left:10px"
          :src=' zfbPhone '
          fit="contain"
          v-else-if="payObj.payChannel == 2"
        ></el-image>
      </div>
      <div style="display:flex;justify-content:center">
        <div
          class="background_style btn"
          :style="{backgroundImage: 'url(' + btn_red + ')' }"
          @click="payCancel"
          style="cursor : pointer"
        >
          取消支付
        </div>
      </div>

    </el-dialog>
  </div>


</template>

<script>
import {  getOrderDetailReq , payOrderByWxPCReq  } from '@/api/Order/index'
import {    payStatusReq  } from '@/api/orderPay/index'


export default {
  data() {
    return {
      publicUrl : this.common.publicUrl ,
      weixinPhone :  require('@/assets/image/order/orderPay/weixinphone.png') ,
      zfbPhone :  require('@/assets/image/order/orderPay/zfbphone.png') ,

      btn_red : this.common.publicUrl + '/profile/avatar/u146.png' ,
      btn_black : this.common.publicUrl + '/profile/avatar/u147.png' ,
      orders: {

      } ,
      timeLeft : ''  , //剩余支付时间
      payVisible : false ,
      payObj : {} ,
      companyName:'',

    };
  },

  methods: {
    getOrderDetail(){
      return new Promise( (resolve, reject) => {
        getOrderDetailReq({
          orderNo : this.obj.orderNo ,
        }).then( res => {

          if (res.data.status == 0) {
            this.companyName =res.data.companyName;
            res.data.orders.receiverPhone_ = res.data.orders.receiverPhone.substring( 0 , 3 ) + '****' + res.data.orders.receiverPhone.substring( res.data.orders.receiverPhone.length -4  )
            this.orders = res.data.orders

            if( this.orders.orderType == 1 && !this.orders.presaleStatus ){
              return
            }
            let orders = this.orders
            this.timer1 = setInterval(() => { //注意箭头函数！！
              let createTime_zhuan = orders.createTime;
              let createTime = createTime_zhuan.replace(/\-/g , '/');
              let createTime_s = new Date(createTime)
              let createTime_g = createTime_s.getTime()

              if( orders.orderType == 1 && orders.presaleStatus == 1 ){ //预订单
                createTime_s.setTime(createTime_g + 1000 * 60 * this.moduleUser.presale_minutes )
              }else if( orders.orderType == 0 ){ //正常订单
                createTime_s.setTime(createTime_g + 1000 * 60 * this.moduleUser.minutes )
              }

              let timeLeft = this.getTimeLeft(createTime_s) //使用了util.getTimeLeft
              // console.log( timeLeft )
              this.timeLeft = timeLeft
            } , 1000)

          }else{
            this.$message({
              message: res.data.statusDesc ,
              type: 'warning'
            });
          }


        })
      })

    },
    // 计算倒计时方法
    getTimeLeft(datetimeTo) {
      // 计算目标与现在时间差（毫秒）
      let time1 = new Date(datetimeTo);
      let time2 = new Date().getTime();
      let mss = time1 - time2;
      if (mss <= 0) {
        return '已过期'
      }

      // 将时间差（毫秒）格式为：天时分秒
      let days = parseInt(mss / (1000 * 60 * 60 * 24));
      let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = parseInt((mss % (1000 * 60)) / 1000);
      // console.log(typeof (days.toString()) )
      return '付款截止剩余时间' + days.toString() + '天' +  hours.toString() +  '时' + minutes.toString() + "分" + seconds.toString() + "秒"
    },
    queryTrack(){

    },
    afterSaleClick(){

    },
    //支付订单
    payOrderClick(){
      let item = this.orders
      if( item.userAgent == "手机端" ){
        this.$message({
          message: '该笔订单不支持PC端支付，请在小程序端商城支付，如有疑问请联系客服',
          type: 'warning'
        });
        return
      }

      if( item.orderType == 1 && !item.payChannel ){ //预订单去支付
        let obj = {
          payPrice : item.payPrice ,
          orderType : item.orderType ,
          payChannel : item.payChannel ,
          orderNo : item.orderNo  ,
          verifyKey : new Date().getTime() ,
        }
        obj = JSON.stringify( obj )
        this.$router.replace({
          path: '/preorderPay',
          query: {
            params : obj
          }
        })
        return
      }

      const loading = this.$loading({
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      payOrderByWxPCReq( {
        orderNo : item.orderNo
      }  ).then( res => {
        loading.close()
        if( res.data.status == 0 ){
          this.payVisible = true
          this.payObj = {
            code_image : res.data.code_image ,
            company : res.data.company ,
            orderNo : res.data.orderNo ,
            price : res.data.price ,
            createTime : res.data.createTime ,
            payChannel : res.data.payChannel ,
          }
          this.timer = setInterval(() => {
            // this.getTimeLeftFunc()
            this.payStatusMethods()
          }, 1000);
        }else{
          this.$message({
            message: res.data.statusDesc  ,
            type: 'warning'
          });
        }

      })

    } ,
    //判断是否支付
    payStatusMethods(){
      payStatusReq({
        orderNo : this.payObj.orderNo
      }).then( res => {
        if( res.data.payStatus == 1 ){
          clearInterval(this.timer);
          this.payVisible = false ;
          let obj  = JSON.stringify(  this.payObj )
          this.payObj = {}

          this.$router.replace({
            path: '/orderSubmit' ,
            query: {
              params : obj
            }
          })

        }
      })
    },
    //取消支付
    payCancel(){
      this.payVisible = false
      clearInterval(this.timer);
    },
    //去商品详情
    gotoDetail(item){
      let goodsId = item.goodsId
      let jancode = item.jancode
      this.$router.push({
        path: '/goodDetail',
        query: {
          goodsId: goodsId ,
          jancode : jancode
        }
      })
    }
  },
  created(){
    let obj =  JSON.parse( this.$route.query.params )
    this.obj = obj
    this.getOrderDetail().then( () => {
      this.queryTrack()
    } )
  },
  computed : {
    moduleUser() {
      return this.$store.state.moduleUser; // 这里返回的是：{name: 'wang', age: 22}
    }
  },
  beforeDestroy() {
    //清除定时器
    clearInterval(this.timer);
    clearInterval(this.timer1);

  },
};
</script>

<style scoped lang="stylus">
.cont_inner >>> .el-table--enable-row-hover .el-table__row:hover{
  cursor : pointer
}
</style>
